import React, { useState } from "react";
import { Button, Typography, message } from "antd";
import { stopServerTaskExec } from "../../apis/mgmt/api";

const StopServerButton = () => {
    const [numero, setNumero] = useState(null as number | null);

    const onClick = async () => {
        try {
            const resultado = await stopServerTaskExec();
            setNumero(resultado.data);
        } catch (error) {
            message.error("Error al consultar el servicio");
        }
    };

    return (
        <Button type="primary" onClick={onClick}>
            {numero !== null ? numero : '-'}
        </Button>
    );

};

export default StopServerButton;
